import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
  openErrorNotification,
  openSuccessNotification,
} from '../../utils/openNotification'
import i18n from 'lang'
import VpsService from 'services/VpsService'

export const initialState = {
  sshKeys: null,
  datacenters: null,
  templates: null,
  catalog: null,
  postVpsIsLoading: false,
  postSshIsLoading: false,
  editSshIsLoading: false,
  vpsList: null,
  vpsListIsLoading: false,
  ipProviders: null,
  ipProvidersIsLoading: false,
  vpsSettings: null,
  vpsSettingsIsLoading: false,
  stopVpsIsLoading: false,
  shutdownVpsIsLoading: false,
  restartVpsIsLoading: false,
  deleteVpsIsLoading: false,
  rebuildVpsIsLoading: false,
}

export const listSshKeys = createAsyncThunk(
  'vps/listSshKeys',
  async (_, { rejectWithValue }) => {
    try {
      return await VpsService.listSshKeys()
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const getVpsRemote = createAsyncThunk(
  'vps/getVpsRemote',
  async ({ id }, { rejectWithValue }) => {
    try {
      return await VpsService.getVpsRemote(id)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const getVncPassword = createAsyncThunk(
  'vps/getVncPassword',
  async ({ id }, { rejectWithValue }) => {
    try {
      return await VpsService.getVncPassword(id)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const listDatacenters = createAsyncThunk(
  'vps/listDatacenters',
  async (_, { rejectWithValue }) => {
    try {
      return await VpsService.listDatacenters()
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const listTemplates = createAsyncThunk(
  'vps/listTemplates',
  async (_, { rejectWithValue }) => {
    try {
      return await VpsService.listTemplates()
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const listCatalog = createAsyncThunk(
  'vps/listCatalog',
  async (_, { rejectWithValue }) => {
    try {
      return await VpsService.listCatalog()
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const postVps = createAsyncThunk(
  'vps/postVps',
  async (data, { rejectWithValue }) => {
    try {
      return await VpsService.postVps(data)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const resizeVps = createAsyncThunk(
  'vps/resizeVps',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return await VpsService.resizeVps(id, data)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const postSsh = createAsyncThunk(
  'vps/postSsh',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await VpsService.postSsh(data)

      dispatch(listSshKeys())

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const editSsh = createAsyncThunk(
  'vps/editSsh',
  async ({ id, data }, { rejectWithValue, dispatch }) => {
    try {
      const response = await VpsService.editSsh(id, data)

      dispatch(listSshKeys())

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const deleteSsh = createAsyncThunk(
  'vps/deleteSsh',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await VpsService.deleteSsh(id)
      dispatch(listSshKeys())

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const listVps = createAsyncThunk(
  'vps/listVps',
  async (_, { rejectWithValue }) => {
    try {
      return await VpsService.listVps()
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const getIpProviders = createAsyncThunk(
  'vps/getIpProviders',
  async (_, { rejectWithValue }) => {
    try {
      return await VpsService.getIpProviders()
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const getSettings = createAsyncThunk(
  'vps/getSettings',
  async (_, { rejectWithValue }) => {
    try {
      return await VpsService.getSettings()
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const startVps = createAsyncThunk(
  'vps/startVps',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await VpsService.startVps(data)

      dispatch(listVps())

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const stopVps = createAsyncThunk(
  'vps/stopVps',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await VpsService.stopVps(data)

      dispatch(listVps())

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const restartVps = createAsyncThunk(
  'vps/restartVps',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await VpsService.restartVps(data)

      dispatch(listVps())

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const shutdownVps = createAsyncThunk(
  'vps/shutdownVps',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await VpsService.shutdownVps(data)

      dispatch(listVps())

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const deleteVps = createAsyncThunk(
  'vps/deleteVps',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await VpsService.deleteVps(data)

      dispatch(listVps())

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const rebuildVps = createAsyncThunk(
  'vps/rebuildVps',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await VpsService.rebuildVps(data)

      dispatch(listVps())

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const getVps = createAsyncThunk(
  'vps/getVps',
  async (data, { rejectWithValue }) => {
    try {
      return await VpsService.getVps(data)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const vpsSlice = createSlice({
  name: 'vps',
  initialState,
  reducers: {
    resetVpsError: state => {
      state.vpsError = null
    },
  },
  extraReducers: builder => {
    builder.addCase(listSshKeys.fulfilled, (state, action) => {
      state.sshKeys = action.payload
    })
    builder.addCase(listDatacenters.fulfilled, (state, action) => {
      state.datacenters = action.payload
    })
    builder.addCase(listTemplates.fulfilled, (state, action) => {
      state.templates = action.payload
    })
    builder.addCase(listCatalog.fulfilled, (state, action) => {
      state.catalog = action.payload
    })
    builder.addCase(postVps.pending, state => {
      state.postVpsIsLoading = true
    })
    builder.addCase(postVps.fulfilled, state => {
      state.postVpsIsLoading = false

      openSuccessNotification({
        key: 'postVps',
        message: i18n.t('message.create.vps.success'),
      })
    })
    builder.addCase(postVps.rejected, (state, action) => {
      state.postVpsIsLoading = false

      openErrorNotification({
        key: 'postVps',
        message: i18n.t(action.payload),
      })
    })

    builder.addCase(resizeVps.pending, state => {
      state.resizeVpsIsLoading = true
    })
    builder.addCase(resizeVps.fulfilled, state => {
      state.resizeVpsIsLoading = false

      openSuccessNotification({
        key: 'resizeVps',
        message: i18n.t('message.resize.vps.success'),
      })
    })
    builder.addCase(resizeVps.rejected, (state, action) => {
      state.resizeVpsIsLoading = false

      openErrorNotification({
        key: 'resizeVps',
        message: action.payload
          ? i18n.t(action.payload)
          : i18n.t('message.default.error'),
      })
    })

    builder.addCase(deleteSsh.pending, () => {})
    builder.addCase(deleteSsh.fulfilled, () => {
      openSuccessNotification({
        key: 'deleteSsh',
        message: i18n.t('message.delete.ssh.success'),
      })
    })
    builder.addCase(deleteSsh.rejected, (state, action) => {
      openErrorNotification({
        key: 'deleteSsh',
        message: action.payload
          ? i18n.t(action.payload)
          : i18n.t('message.default.error'),
      })
    })
    builder.addCase(editSsh.pending, state => {
      state.editSshIsLoading = true
    })
    builder.addCase(editSsh.fulfilled, state => {
      state.editSshIsLoading = false

      openSuccessNotification({
        key: 'editSsh',
        message: i18n.t('message.update.ssh.success'),
      })
    })
    builder.addCase(editSsh.rejected, (state, action) => {
      state.editSshIsLoading = false

      openErrorNotification({
        key: 'editSsh',
        message: action.payload || i18n.t('message.default.error'),
      })
    })
    builder.addCase(postSsh.pending, state => {
      state.postSshIsLoading = true
    })
    builder.addCase(postSsh.fulfilled, state => {
      state.postSshIsLoading = false

      openSuccessNotification({
        key: 'postSsh',
        message: i18n.t('message.create.ssh.success'),
      })
    })
    builder.addCase(postSsh.rejected, (state, action) => {
      state.postSshIsLoading = false

      openErrorNotification({
        key: 'postSsh',
        message: action.payload || i18n.t('message.default.error'),
      })
    })
    builder.addCase(listVps.pending, state => {
      state.vpsListIsLoading = true
    })
    builder.addCase(listVps.fulfilled, (state, action) => {
      state.vpsListIsLoading = false
      state.vpsList = action.payload
    })
    builder.addCase(listVps.rejected, state => {
      state.vpsListIsLoading = false
    })
    builder.addCase(getIpProviders.pending, state => {
      state.ipProvidersIsLoading = true
    })
    builder.addCase(getIpProviders.fulfilled, (state, action) => {
      state.ipProvidersIsLoading = false
      state.ipProviders = action.payload.list
    })
    builder.addCase(getIpProviders.rejected, state => {
      state.ipProvidersIsLoading = false
    })
    builder.addCase(getSettings.pending, state => {
      state.vpsSettingsIsLoading = true
    })
    builder.addCase(getSettings.fulfilled, (state, action) => {
      state.vpsSettings = action.payload
    })
    builder.addCase(getSettings.rejected, state => {
      state.vpsSettingsIsLoading = false
    })
    builder.addCase(startVps.pending, () => {})
    builder.addCase(startVps.fulfilled, () => {
      openSuccessNotification({
        key: 'startVps',
        message: i18n.t('message.start.vps.success'),
      })
    })
    builder.addCase(startVps.rejected, (_, action) => {
      openErrorNotification({
        key: 'startVps',
        message: action.payload
          ? i18n.t(action.payload)
          : i18n.t('message.default.error'),
      })
    })
    builder.addCase(stopVps.pending, state => {
      state.stopVpsIsLoading = true
    })
    builder.addCase(stopVps.fulfilled, state => {
      state.stopVpsIsLoading = false
      openSuccessNotification({
        key: 'stopVps',
        message: i18n.t('message.stop.vps.success'),
      })
    })
    builder.addCase(stopVps.rejected, (state, action) => {
      state.stopVpsIsLoading = false
      openErrorNotification({
        key: 'stopVps',
        message: action.payload
          ? i18n.t(action.payload)
          : i18n.t('message.default.error'),
      })
    })
    builder.addCase(restartVps.pending, state => {
      state.restartVpsIsLoading = true
    })
    builder.addCase(restartVps.fulfilled, state => {
      state.restartVpsIsLoading = false
      openSuccessNotification({
        key: 'restartVps',
        message: i18n.t('message.restart.vps.success'),
      })
    })
    builder.addCase(restartVps.rejected, (state, action) => {
      state.restartVpsIsLoading = false
      openErrorNotification({
        key: 'restartVps',
        message: action.payload
          ? i18n.t(action.payload)
          : i18n.t('message.default.error'),
      })
    })
    builder.addCase(shutdownVps.pending, state => {
      state.shutdownVpsIsLoading = true
    })
    builder.addCase(deleteVps.pending, state => {
      state.deleteVpsIsLoading = true
    })
    builder.addCase(deleteVps.fulfilled, state => {
      state.deleteVpsIsLoading = false
      openSuccessNotification({
        key: 'deleteVps',
        message: i18n.t('message.delete.vps.success'),
      })
    })
    builder.addCase(deleteVps.rejected, (state, action) => {
      state.deleteVpsIsLoading = false
      openSuccessNotification({
        key: 'deleteVps',
        message: action.payload
          ? i18n.t(action.payload)
          : i18n.t('message.default.error'),
      })
    })
    builder.addCase(shutdownVps.fulfilled, state => {
      state.shutdownVpsIsLoading = false
      openSuccessNotification({
        key: 'shutdownVps',
        message: i18n.t('message.shutdown.vps.success'),
      })
    })
    builder.addCase(shutdownVps.rejected, (state, action) => {
      state.shutdownVpsIsLoading = false
      openErrorNotification({
        key: 'shutdownVps',
        message: action.payload || i18n.t('message.default.error'),
      })
    })
    builder.addCase(rebuildVps.pending, state => {
      state.rebuildVpsIsLoading = true
    })
    builder.addCase(rebuildVps.fulfilled, state => {
      state.rebuildVpsIsLoading = false
      openSuccessNotification({
        key: 'rebuildVps',
        message: i18n.t('message.rebuild.vps.success'),
      })
    })
    builder.addCase(rebuildVps.rejected, (state, action) => {
      state.rebuildVpsIsLoading = false
      openErrorNotification({
        key: 'rebuildVps',
        message: action.payload
          ? i18n.t(action.payload)
          : i18n.t('message.default.error'),
      })
    })
  },
})

export default vpsSlice.reducer
